import React from 'react';
import { TripSummaryCard } from '@pcln/cards';
import getMediaNode from '../helpers/getMediaNode';
import TripDates, { getDates } from '../helpers/TripDates';
import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
import { parseISO } from 'date-fns/parseISO';
const HOTEL_START_DATE_LABEL = 'Check-in';
const HOTEL_END_DATE_LABEL = 'Check-out';
const getHotelCaption = (startDateIso, endDateIso, destination) => {
  const differenceInDays = differenceInCalendarDays(parseISO(endDateIso), parseISO(startDateIso));
  const delimitter = destination && !isNaN(differenceInDays) ? ' • ' : '';
  return `${destination}${delimitter}${!isNaN(differenceInDays) ? differenceInDays + ' Night Stay' : ''}`;
};
/** @public */
const UpcomingHotel = ({
  hotelName,
  destination,
  travelStartDate,
  travelEndDate,
  truncateHeading,
  showArrowRight,
  onClick,
  handleSubmitCTA,
  actionText,
  imageUrl,
  buttonNode
}) => {
  const [startDate, endDate] = getDates(travelStartDate, travelEndDate);
  return React.createElement(TripSummaryCard, {
    mediaNode: getMediaNode('STAY', imageUrl),
    mediaNodeBackgroundColor: imageUrl ? 'transparent' : 'primary.light',
    heading: hotelName,
    noTranslateHeading: true,
    caption: getHotelCaption(travelStartDate, travelEndDate, destination),
    body: React.createElement(TripDates, {
      startDateLabel: HOTEL_START_DATE_LABEL,
      endDateLabel: HOTEL_END_DATE_LABEL,
      startDate: startDate,
      endDate: endDate
    }),
    truncateHeading: truncateHeading,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA,
    actionText: actionText,
    buttonNode: buttonNode
  });
};
export default UpcomingHotel;